import React, { useEffect, useState } from "react"
import { Link } from "gatsby"
import { navigate } from "gatsby-link"
import { getProfileData } from "../urls"
import "../styles/header.css"
import { BiSearch } from "react-icons/bi"
import TesCube from "../images/tes-cube-sq.jpg"
import pp1 from "../images/profile-pic-1.jpeg"
import pp2 from "../images/profile-pic-2.jpeg"
import pp3 from "../images/profile-pic-3.jpeg"
import pp4 from "../images/profile-pic-4.jpeg"
import pp5 from "../images/profile-pic-5.jpeg"
import pp6 from "../images/profile-pic-6.jpeg"
import axios from "axios"
import Cookies from "universal-cookie"

const cookies = new Cookies()

const Header = ({ receivedProfile }) => {
    const [pp, setPp] = useState({});
    const [selectedProfile, setSelectedProfile] = useState(receivedProfile);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
        if (!receivedProfile) {
            axios.post(getProfileData, {
                'code': cookies.get('code'),
                'prof_code': cookies.get('prof_code')
            })
            .then(res => setSelectedProfile(res.data.profile))
            .catch(err => {
                console.error(err)/* eslint-disable no-unused-expressions */
                typeof window !== "undefined" ? navigate('select-profile') : null
            })
        }
    }, [])

    useEffect(() => {
        if (selectedProfile) {
            setPp(selectedProfile.profile_pic_id === 1 ?
                pp1 : selectedProfile.profile_pic_id === 2 ?
                    pp2 : selectedProfile.profile_pic_id === 3 ?
                        pp3 : selectedProfile.profile_pic_id === 4 ?
                            pp4 : selectedProfile.profile_pic_id === 5 ?
                                pp5 : pp6)
        }
    }, [selectedProfile])

    const searchData = (e) => {
        if (typeof window !== "undefined"){
            if (e) {
                if (e.key === 'Enter') {
                    setLoading(true);
                    navigate(`/search?q=${e.target.value}`);
                    setTimeout(() => {
                        setLoading(false);
                    }, 500)
                } else {
                    setLoading(false);
                }
            }
            else {
                setLoading(true);
                navigate(`/search?q=${document.getElementById("header-search-bar").value}`);
                setTimeout(() => {
                    setLoading(false);
                }, 500)
            }
        }
    }

    return <div className="header-outer">
        <div className="header-body">
            <div className="header-center">
                <div className="header-cube">
                    <Link to="/">
                        <img src={TesCube} alt="Tesseract Cube" />
                    </Link>
                </div>
                <div className="header-branding">
                    <Link to="/">
                        TESERAKT
                    </Link>
                </div>
                <div className="header-cube">
                    <Link to="/profile">
                        {
                            typeof pp === "string" ?
                            <img src={pp} alt="Profile Pic" /> :
                            <div className="header-cube-filler">
                                <span id="loading"></span>
                            </div>
                        }
                    </Link>
                </div>
            </div>
        </div>
        <div className="header-search">
            <input
                id="header-search-bar"
                className="header-search-bar"
                placeholder="Search By Name..."
                onKeyDown={e => searchData(e)}
                autoComplete="off"
            />
            <div
                className="header-search-icon"
                role="button"
                tabIndex={0}
                onClick={e => searchData()}
                onKeyDown={e => searchData()}
            >
                {
                    loading ? <span id="loading"></span> : <BiSearch />
                }
            </div>
        </div>
    </div>
}

export default Header